
import Vue from 'vue'

import convertCase from '@/mixins/convert-case'

export default Vue.extend({
  props: ['route', 'text', 'icon'],

  mixins: [convertCase],

  computed: {
    arenaId() {
      return this.$store.getters.arena ? `/${this.$store.getters.arena.id}` : ''
    },
  },
})
